<template>
    <div class="p-admin-configurations">
        <div class="row justify-content-center">
            <div class="col-lg-3">
                <ul v-if="isExtra" class="list-group mb-3">
                    <li class="list-group-item" :class="{ 'active' : active === 1 }" @click="onClick(1)">タイムゾーン設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 2 }" @click="onClick(2)">決済設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 3 }" @click="onClick(3)">請求書設定</li>
<!--                    <li class="list-group-item" :class="{ 'active' : active === 4 }" @click="onClick(4)">プラン設定</li>-->
                    <li class="list-group-item" :class="{ 'active' : active === 5 }" @click="onClick(5)">管理機能設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 6 }" @click="onClick(6)">メンテナンス設定</li>
                </ul>
                <ul v-else class="list-group mb-3">
                    <li class="list-group-item" :class="{ 'active' : active === 1 }" @click="onClick(1)">基本設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 2 }" @click="onClick(2)">{{ $locale.consultation_host }}設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 3 }" @click="onClick(3)">{{ $locale.patient }}区分一覧</li>
                    <li class="list-group-item" :class="{ 'active' : active === 4 }" @click="onClick(4)">所属コード設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 5 }" @click="onClick(5)">キャンセルポリシー</li>
                    <li class="list-group-item" :class="{ 'active' : active === 6 }" @click="onClick(6)">規約関連設定</li>
                    <li class="list-group-item" :class="{ 'active' : active === 7 }" @click="onClick(7)">メール設定</li>
                </ul>
            </div>

            <div v-if="isExtra" class="col-lg-9">
                <div v-show="active === 1">
                    <admin-conf-timezone :conf="confTimezone"/>
                </div>
                <div v-show="active === 2">
                    <admin-conf-payment
                        :conf="confPayment"
                        :payment-methods="paymentMethods">
                    </admin-conf-payment>
                </div>
                <div v-show="active === 3">
                    <admin-conf-invoice :conf="confInvoice"/>
                </div>
<!--                <div v-show="active === 4">-->
<!--                    <admin-conf-subscription :conf="confSubscription"/>-->
<!--                </div>-->
                <div v-show="active === 5">
                    <admin-conf-admin :conf="confAdmin"/>
                </div>
                <div v-show="active === 6">
                    <admin-conf-maintenance :conf="confMaintenance"/>
                </div>
            </div>
            <div v-else class="col-lg-9">
                <div v-show="active === 1">
                    <admin-conf-basic :conf="confBasic"/>
                </div>
                <div v-show="active === 2">
                    <admin-conf-consultation :conf="confConsultation"/>
                </div>
                <div v-show="active === 3">
                    <admin-conf-user-categories />
                </div>
                <div v-show="active === 4">
                    <admin-conf-user-code :conf="confUser" />
                </div>
                <div v-show="active === 5">
                    <admin-conf-cancel-policy :conf="confCancelPolicy"/>
                </div>
                <div v-show="active === 6">
                    <admin-conf-law :conf="confLaw" :app-url="appUrl"></admin-conf-law>
                </div>
                <div v-show="active === 7">
                    <admin-conf-mail :conf="confMail" :app-url="appUrl"></admin-conf-mail>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import constants from '../../constants'
    import AdminConfConsultation from './configurations/AdminConfConsultation'

    export default {
        props: {
            appUrl: {
                type: String,
                required: true,
            },
        },

        components: {
            AdminConfConsultation
        },

        data: function () {
            return {
                configurations: [],
                paymentMethods: [],
                active: 1,
            }
        },

        computed: {
            confBasic: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.basic
                })
            },

            confConsultation: function () {
                return this.configurations.filter(conf => {
                    return [
                        constants.confCategory.consultation,
                        constants.confCategory.medical_record,
                    ].includes(conf.category) && conf.key !== 'consultation_cancel_policy'
                })
            },

            confUser: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.user
                })
            },

            confCancelPolicy: function () {
                return this.configurations.filter(conf => {
                    return conf.key === 'consultation_cancel_policy'
                })
            },

            confLaw: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.law
                })
            },

            confMail: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.mail
                })
            },

            /**
             * 隠しURLモード判定
             */
            isExtra: function () {
                return this.$route.query.extra === '1'
            },

            confTimezone: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.timezone
                })
            },

            confPayment: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.payment
                })
            },

            confInvoice: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.invoice
                })
            },

            confSubscription: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.subscription
                })
            },

            confAdmin: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.admin
                })
            },

            confMaintenance: function () {
                return this.configurations.filter(conf => {
                    return conf.category === constants.confCategory.maintenance
                })
            },
        },

        created: function () {
            this.fetchConfigurations()
            this.fetchPaymentMethods()
        },

        methods: {
            /**
             * 設定取得
             */
            fetchConfigurations: function () {
                this.configurations = []

                axios.get(constants.admin.configurations.endpoint.all)
                    .then(({data}) => {
                        this.configurations = data
                    })
            },

            /**
             * お支払い方法取得
             */
            fetchPaymentMethods: function () {
                this.paymentMethods = []

                axios.get(constants.admin.payment_methods.endpoint.all)
                    .then(({data}) => {
                        this.paymentMethods = data.data
                    })
            },

            /**
             * 設定リスト選択時
             *
             * @param {number} active
             */
            onClick: function(active) {
                this.active = active
            },
        },
    };
</script>

<style scoped lang="scss">
.p-admin-configurations {
    .list-group-item {
        cursor: pointer;

        &.active {
            cursor: default;
            border-color: #3daf73;
            background-color: #3daf73;
        }
    }
}
</style>
